/**
 * @generated SignedSource<<6391fbfa407b55d68479452b9fc0e582>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type introduceEditorUpdatePublicMutation$variables = {
  public: boolean;
  userId: string;
};
export type introduceEditorUpdatePublicMutation$data = {
  readonly update_insurance_agent_by_pk: {
    readonly id: string;
  } | null | undefined;
};
export type introduceEditorUpdatePublicMutation = {
  response: introduceEditorUpdatePublicMutation$data;
  variables: introduceEditorUpdatePublicMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "public"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "userpubliccontent",
            "variableName": "public"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "pk_columns"
      }
    ],
    "concreteType": "insurance_agent",
    "kind": "LinkedField",
    "name": "update_insurance_agent_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "introduceEditorUpdatePublicMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "introduceEditorUpdatePublicMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "93cf540d573f2d59c01fe1fb0c4c11cd",
    "id": null,
    "metadata": {},
    "name": "introduceEditorUpdatePublicMutation",
    "operationKind": "mutation",
    "text": "mutation introduceEditorUpdatePublicMutation(\n  $userId: String!\n  $public: Boolean!\n) {\n  update_insurance_agent_by_pk(pk_columns: {id: $userId}, _set: {userpubliccontent: $public}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a711953ea75b760b436201c8809abbd9";

export default node;
